import {AxiosError} from 'axios';
import BASE_URL from '../../config/env';
import {
  BackendErrorData,
  parseApiErrorWithLocalization,
} from '../../utils/custom-errors/parseApiError';
import {apiClient} from '../apiClient';
import {
  IAISummarizeJobResponse,
  IAISummaryJobsPayload,
  ICreateAISummaryJobPayload,
  AISummaryForDocumentRequest,
  AISummaryForDocumentResponse,
  ISummarizationNavigationPayload,
} from '../types/aiSummarization.type';
import {IGetDownloadDocumentResponse} from '../types/document.type';

const aiSummaryEndpoint = (path: string | number) =>
  `${BASE_URL}/ai/api/v1/summarization/${path}`;

export const retryAiSummary = async (jobId: number) => {
  const {data} = await apiClient.post(aiSummaryEndpoint(`jobs/retry/${jobId}`));
  return data;
};

export const deleteAiSummary = async (jobId: number) => {
  const {data} = await apiClient.delete(aiSummaryEndpoint(`jobs/${jobId}`));
  return data;
};

export const getAISummaryJobs = async (
  payload: IAISummaryJobsPayload
): Promise<IAISummarizeJobResponse> => {
  const {data} = await apiClient.post(aiSummaryEndpoint('jobs/list'), payload);
  return data;
};

export const navigateSummarization = async (
  payload: ISummarizationNavigationPayload
) => {
  const {data} = await apiClient.post(
    aiSummaryEndpoint('aisummarizenavigation'),
    payload
  );
  return data;
};

export const getCsvDownload =
  async (): Promise<IGetDownloadDocumentResponse> => {
    try {
      const response = await apiClient.get(aiSummaryEndpoint('download'), {
        responseType: 'blob',
        headers: {
          Accept: 'text/csv',
        },
      });

      const disposition = response.headers['content-disposition'];
      const match = disposition?.match(/filename\*=UTF-8''(.+)$/);
      const filename = match ? decodeURIComponent(match[1]) : 'document';

      return {
        blob: response.data,
        filename: filename,
        contentDisposition: disposition,
      };
    } catch (error) {
      throw parseApiErrorWithLocalization(
        error as AxiosError<BackendErrorData>,
        'docViewerPanel'
      );
    }
  };

export const getSourceTypes = async (moduleName: string): Promise<any> => {
  const {data} = await apiClient.get(
    `${BASE_URL}/ai/api/v1/ai/sourcetypes?moduleName=${moduleName}`
  );
  return data;
};

export const createNewAISummaryJob = async (
  payload: ICreateAISummaryJobPayload
): Promise<any> => {
  const {data} = await apiClient.post(aiSummaryEndpoint('jobs'), payload);
  return data;
};

export const getAISummaryForDocument = async (
  payload: AISummaryForDocumentRequest
): Promise<AISummaryForDocumentResponse> => {
  const {data} = await apiClient.post(
    aiSummaryEndpoint(`documents/summary`),
    payload
  );
  return data;
};
